import { useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { useSettingsStore, useWorkspaceStore } from "@/stores";

/**
 * WorkspaceSwitcher
 *
 * Native `<select>` by design, matching `ModelPicker`'s precedent — a
 * workspace list is exactly the kind of control that doesn't need a custom
 * dropdown. Switching calls `workspaceStore.setActive`, the single seam that
 * reloads every workspace-scoped store (see `WORKSPACE_SYSTEM.md`).
 */
export function WorkspaceSwitcher({ collapsed }: { collapsed: boolean }) {
  const workspaces = useWorkspaceStore((s) => s.workspaces);
  const init = useWorkspaceStore((s) => s.init);
  const setActive = useWorkspaceStore((s) => s.setActive);
  const activeWorkspaceId = useSettingsStore((s) => s.activeWorkspaceId);

  useEffect(() => {
    void init();
  }, [init]);

  if (collapsed) return null;

  return (
    <div className="relative px-1">
      <select
        value={activeWorkspaceId}
        onChange={(e) => void setActive(e.target.value)}
        aria-label="Workspace"
        className="no-drag h-7 w-full appearance-none rounded-md border border-transparent bg-transparent pl-1.5 pr-6 text-sm font-medium text-text-secondary transition-colors hover:border-border hover:bg-bg-hover focus:border-border-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus"
      >
        {workspaces.map((w) => (
          <option key={w.id} value={w.id}>
            {w.name}
          </option>
        ))}
      </select>
      <ChevronDown
        size={12}
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-text-tertiary"
        aria-hidden
      />
    </div>
  );
}
